import { createSlice } from "@reduxjs/toolkit";
import {
  getAiReport,
  createPatient,
  confirmSummary,
  sendPatientNotification,
  getAllPatients,
  getVisitRecords,
  deleteTreatment,
  updateVisitRecord,
  getDashboardStats,
  createVisitRecord,
  createPatientVisit,
  getAllPatientVisits,
  getAllTreatmentCodes,
  addTreatmentActivity,
  deleteTreatmentActivity,
  getAllTreatmentActivities,
} from "./doctorApi";

export const doctorSlice = createSlice({
  name: "doctor",
  initialState: {
    error: null,
    loading: "idle",
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPatients.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getAllPatients.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getAllPatients.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createPatient.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createPatient.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(createPatient.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getAllPatientVisits.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getAllPatientVisits.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getAllPatientVisits.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createPatientVisit.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createPatientVisit.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(createPatientVisit.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getAllTreatmentCodes.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getAllTreatmentCodes.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getAllTreatmentCodes.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createVisitRecord.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createVisitRecord.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(createVisitRecord.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getVisitRecords.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getVisitRecords.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getVisitRecords.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(addTreatmentActivity.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(addTreatmentActivity.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(addTreatmentActivity.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getAllTreatmentActivities.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getAllTreatmentActivities.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getAllTreatmentActivities.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(confirmSummary.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(confirmSummary.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(confirmSummary.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(sendPatientNotification.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(sendPatientNotification.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(sendPatientNotification.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getDashboardStats.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getDashboardStats.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getDashboardStats.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(deleteTreatment.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deleteTreatment.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deleteTreatment.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(deleteTreatmentActivity.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deleteTreatmentActivity.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deleteTreatmentActivity.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(updateVisitRecord.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(updateVisitRecord.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(updateVisitRecord.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getAiReport.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getAiReport.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getAiReport.rejected, (state) => {
        state.loading = "failed";
      });
  },
});

export const { setLoading } = doctorSlice.actions;

export default doctorSlice.reducer;
